import { Component, Inject } from '@angular/core';
import { Position } from 'src/app/models/pallet-rack-interfaces';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-pallet-racks-modal',
  templateUrl: './pallet-racks-modal.component.html',
  styleUrls: ['./pallet-racks-modal.component.scss']
})
export class PalletRacksModalComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public position: Position) { }

  getPackageTypeDescription(packageType: number | null): string {
    switch (packageType) {
      case 1:
        return 'Palleted';
      case 2:
        return 'Carton';
      case 3:
        return 'Crate';
      case 4:
        return 'Loose / Floor';
      case 5:
        return 'Bin';
      default:
        return 'Unknown';
    }
  }


}
